define('modules/editor/views/elements/social_facebook',['require','exports','module','backbone'],function(require, exports, module) {
  "use strict";
  var Backbone = require("backbone");

  module.exports = Backbone.View.extend({
    className: "fb-share-button",
    render: function() {
      module.exports.__super__.render.apply(this, arguments);
      var layout = this.model.get("counter")? "button_count" : "button",
          url = this.model.get("sharedUrl");
      this.$el.attr("data-layout", layout);
      if (url) this.$el.attr("data-href", url);
      return this;
    }
  });
});

